import * as THREE from 'three';

const matrixFromSimd = (matrixSimd) => {
  let matrixTmp = matrixSimd.replace('simd_float4x4(', '');
  matrixTmp = matrixTmp.slice(0, -1);
  matrixTmp = JSON.parse(matrixTmp);

  let plainMatrix = [];
  for (let i = 0; i < 4; i++) {
    for (let j = 0; j < 4; j++) {
      plainMatrix.push(matrixTmp[j][i])
    }
  }

  let m = new THREE.Matrix4();
  m.set(...plainMatrix);

  return m;
};


export {
  matrixFromSimd
}
